import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useTheme } from './ThemeContext';
import { isAdminThemePath } from '../../utils/themeUtils';

// Keep admin theme updates separate from authentication and page rendering.
const AuthenticatedThemeSync = () => {
  const { user, isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  const { applyTheme } = useTheme();
  const companyTheme = user?.company?.theme;
  const hasCompany = Boolean(user?.company);
  const isAdminPage = isAdminThemePath(pathname);

  useLayoutEffect(() => {
    if (isAuthenticated && hasCompany && isAdminPage) {
      applyTheme(companyTheme || 'default');
    }
  }, [isAuthenticated, hasCompany, isAdminPage, companyTheme, applyTheme]);

  return null;
};

export default AuthenticatedThemeSync;
